'use client';
import React from 'react';
import { EventParentPage } from '../../utils/relationships';
import { EventReminderModal } from './EventReminderModal/EventReminderModal';
import { EventReminderButton } from './EventReminderButton/EventReminderButton';

interface EventProps {
  event: EventParentPage;
}

export const EventReminder: React.FC<EventProps> = ({ event }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <EventReminderModal open={isOpen} setOpen={setIsOpen} event={event} />
      <EventReminderButton setOpen={setIsOpen} />
    </>
  );
};
